export default __webpack_public_path__ + "static/media/residential.bef29294.png";